<template>
  <div>已跳转中厚板原料进场页面，请在新页面查看</div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  created () {
    this.tiaoZhuan()
  },
  methods: {
    tiaoZhuan () {
      // window.open('http://any.zw56.com/#/zhb-dp/zhbfinished')
      window.open('http://any.zw56.com/#/zhb-dp/zhbrawMterial')
    }
  }
}
</script>
<style>

</style>
